import { Component } from '@angular/core';
import { Router } from '@angular/router'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { SpinnerDialogComponent } from '../spinner-dialog/spinner-dialog.component'
import { SharedService } from '../../services/shared.service'
import { HttpService } from '../../services/http.service'
import { Product } from '../../models/product'
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component'

@Component({
	selector: 'app-order-summary-dialog',
	templateUrl: './order-summary-dialog.component.html',
	styleUrls: ['./order-summary-dialog.component.css']
})
export class OrderSummaryDialogComponent {
	price: number = 0
	tax: number = 0
	taxrate: number = 0
	total: number = 0
	product: Product
	spinner: MatDialogRef<SpinnerDialogComponent>

	constructor(
		private router: Router,
		private dialog: MatDialog,
		private me: MatDialogRef<OrderSummaryDialogComponent>,
		public shared: SharedService,
		private http: HttpService,
	) {
		this.product = this.shared.product
		this.price = this.shared.price
		this.tax = this.shared.tax
		this.taxrate = this.shared.taxrate
		this.total = this.shared.total
	}

	onConfirm(): void {
		let card = this.shared.card
		let product = this.shared.product
		let user = this.shared.user

		this.spinner = this.dialog.open(SpinnerDialogComponent, {
			panelClass: 'transparent',
			disableClose: true
		})
		this.http.setOrder({
			"paymentInformation": {
				"card": {
					"number": card.number,
					"securityCode": card.securityCode,
					"expirationMonth": card.expirationMonth,
					"expirationYear": card.expirationYear
				}
			},
			"lineItems": [
				{
					"productCode": this.shared.serialNumber,
					"productName": product.MODELCODE,
					"productSku": product.SKU,
					"productDescription": product.TERM,
					"quantity": 1,
					"unitPrice": product.TECHNICIANID ? product.PRICE - product.DISCOUNTAMOUNT : product.PRICE,
					"totalPrice": this.total,
					"taxAmount": this.tax,
					"taxRate": this.taxrate,
				}
			],
			"orderInformation": {
				"amountDetails": {
					"totalAmount": this.total,
					"currency": 'USD'
				},
				"billTo": {
					"firstName": user.firstName,
					"lastName": user.lastName,
					"address1": user.address1,
					"address2": user.address2,
					"locality": user.locality,
					"administrativeArea": user.administrativeArea,
					"postalCode": user.postalCode,
					"country": 'US',
					"email": user.email,
					"phoneNumber": user.phoneNumber,
					"phoneNumber2": user.phoneNumber2
				},
        "technicianId": product.TECHNICIANID,
        "ascNo" : product.ASCNO,
        "ticketNo" : product.TICKETNO,
        "satus" : product.STATUS,
        "discountAmount" : product.DISCOUNTAMOUNT,
			}})
			.subscribe(response => {
				this.spinner.close()
				console.log((response))
				if (response.success) {
					this.shared.contract.contractNo = response.data.contractInfo.contractNo
					this.me.close()
					this.router.navigateByUrl('/complete')
				} else {
					console.log(response)
					this.dialog.open(
						MessageDialogComponent, {
						data: {
							title: '',
							description: response.message,
							button: 'Close'
						}
					})
				}
			}, (error) => {
				this.spinner.close()
				this.dialog.open(
					MessageDialogComponent, {
					data: {
						title: '',
						description: error.message,
						button: 'Close'
					}
				})
			})
	}

	onCancel(): void {
		this.me.close()
	}
}
